import Vue from 'vue'
import VueRouter from 'vue-router'

// VueRouter.prototype.push = function(path) {
//   return routerPush.call(this, path).catch(err => err);
// };

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
  },
]

const router = new VueRouter({
  routes
})

export default router
